import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/konsoll/forbruk")({
	beforeLoad: () => {
		throw redirect({ to: "/account/konsoll/forbruk" });
	},
});
